import api from './api';

async function getVacancyGroupAPI(division: string, searchValue: string) {
  const response = await api.get(
    `group/division/${division}/${searchValue ? `?search=${searchValue}` : ''}`,
  );
  return response?.data;
}

export default getVacancyGroupAPI;
